import api from "../../../api";

export function appLoginDetails(id, pageNumber) {;
  return api.get(`appAndUserDetail/${id}?pageNumber=${pageNumber}&pageSize=10`);
}

export function moengageEventDetails(caseId, pageNumber) {;
  return api.get(`eventMoengage/${caseId}?pageNumber=${pageNumber}&pageSize=10`);
}